




































































import { Component, Mixins } from "vue-property-decorator";
import dateranges from "@/data/dateranges";
import AdminBrandId from "@/mixins/adminBrandId";
import StatsStorageMixin from "@/mixins/statsStorageMixin";
import { routeToAdminLogsFromClient } from "@/data/filters/timeline";

@Component({
  methods: {
    routeToAdminLogsFromClient
  },
  components: {
    "chart-provider": () =>
      import("@/components/app/global/stats/charts/chart/chartProvider.vue"),
    "stat-header": () => import("@/components/app/global/stats/statHeader.vue"),
    "timeline-component": () =>
      import("@/components/app/global/timelineComponent/index.vue"),
    "clients-total-active": () =>
      import("@/components/app/global/stats/clientsTotalActive.vue"),
    "clients-total-new": () =>
      import("@/components/app/global/stats/clientsTotalNew.vue"),
    "chart-clients": () =>
      import("@/components/app/global/stats/charts/clientsChart.vue"),
    "client-search": () =>
      import("@/components/app/global/client/clientSearch.vue")
  }
})
export default class AdminClientsOverview extends Mixins(
  AdminBrandId,
  StatsStorageMixin
) {
  public range = this.tryGetStatDateFromStorage(dateranges.ranges.last30days);
  public currencyCode = null;
}
